import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import anime from 'animejs/lib/anime.es.js';

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import News from "@/components/News/index";
import SvgsCommons from "@/components/svgs/commons";
import { useActionWhenScrollToView } from '@/utils/index'
import { newPath, EmailLink, SubLink, SubHubLink, SubhubHost, NFTsLink } from '@/utils/index'
import { HomeNewsList } from '@/pages2/news/utils'
import { getHomeData } from '@/api/index'
import { ProtocolSvg } from './protocol'
import { useAutoSlide, NumberAnime } from './utils'
import { Root, Chunk1, Chunk2, Chunk3, Chunk4, Chunk5, Chunk6 } from './css'

import Chain1 from '@/static/images/newHome/chain1.png'
import Chain2 from '@/static/images/newHome/chain2.png'
import Chain3 from '@/static/images/newHome/chain3.png'
import Chain4 from '@/static/images/newHome/chain4.png'
import Chain5 from '@/static/images/newHome/chain5.png'
import Chain6 from '@/static/images/newHome/chain6.png'
import Chain7 from '@/static/images/newHome/chain7.png'
import Chain8 from '@/static/images/newHome/chain8-2.png'
import Chain9 from '@/static/images/newHome/chain9.png'
import Chain10 from '@/static/images/newHome/chain10.png'
import Chain11 from '@/static/images/newHome/chain11.png'
import Chain12 from '@/static/images/newHome/chain12.png'
import Chain13 from '@/static/images/newHome/chain13.png'
import Chain14 from '@/static/images/newHome/chain14.png'
import Chain15 from '@/static/images/newHome/chain15.png'
import Chain16 from '@/static/images/newHome/chain16.png'
import Chain17 from '@/static/images/newHome/chain17.png'
import Chain18 from '@/static/images/newHome/chain18.png'

import Did1 from '@/static/images/newHome/did1.png'
import Did2 from '@/static/images/newHome/did2.png'
import Did3 from '@/static/images/newHome/did3.png'
import Did4 from '@/static/images/newHome/did4.png'
import Did5 from '@/static/images/newHome/did5.png'
import Did6 from '@/static/images/newHome/did6.png'
import Did7 from '@/static/images/newHome/did7.png'
import Did8 from '@/static/images/newHome/did8.png'
import Did9 from '@/static/images/newHome/did9.png'
import Did10 from '@/static/images/newHome/did10.png'
import Did11 from '@/static/images/newHome/did11.png'
import Did12 from '@/static/images/newHome/did12.png'
import Did13 from '@/static/images/newHome/did13.png'
import Did14 from '@/static/images/newHome/did14.png'
import Did15 from '@/static/images/newHome/did15.png'
import Did16 from '@/static/images/newHome/did16.webp'

import Supporter1 from '@/static/images/newHome/supporter1.png'
import Supporter2 from '@/static/images/newHome/supporter2.png'
import Supporter3 from '@/static/images/newHome/supporter3.png'
import Supporter4 from '@/static/images/newHome/supporter4.png'
import Supporter5 from '@/static/images/newHome/supporter5.png'
import Supporter6 from '@/static/images/newHome/supporter6.png'
import Supporter7 from '@/static/images/newHome/supporter7.png'
import Supporter8 from '@/static/images/newHome/supporter8.png'
import Supporter9 from '@/static/images/newHome/supporter9.png'
import Supporter10 from '@/static/images/newHome/supporter10.png'

import Partner1 from '@/static/images/newHome/partner1.png'
import Partner2 from '@/static/images/newHome/partner2.png'
import Partner3 from '@/static/images/newHome/partner3.png'
import Partner4 from '@/static/images/newHome/partner4.png'
import Partner5 from '@/static/images/newHome/partner5.png'
import Partner6 from '@/static/images/newHome/partner6.png'
import Partner7 from '@/static/images/newHome/partner7.png'
import Partner8 from '@/static/images/newHome/partner8.png'

import MP9 from '@/static/images/newHome/mp1.png'
import MP10 from '@/static/images/newHome/mp2.png'
import MP11 from '@/static/images/newHome/mp3.png'
import MP12 from '@/static/images/newHome/mp4.png'

import DmailDapp from '@/static/images/newHome/dmail-dapp.png'
import SubHub from '@/static/images/newHome/sub-hub2.png'
import MarketHub from '@/static/images/newHome/market-hub.png'
import Protocol1 from '@/static/images/newHome/protocol.png'

import Nft3D541 from '@/static/images/newHome/541.png'
import Nft3D600 from '@/static/images/newHome/600.png'
import Nft3D735 from '@/static/images/newHome/735.png'
import Nft3D1927 from '@/static/images/newHome/1927.png'
import Nft3D425 from '@/static/images/newHome/425.png'
import Nft3D2211 from '@/static/images/newHome/2211.png'
import Nft3D827 from '@/static/images/newHome/827.png'
import Nft3D816 from '@/static/images/newHome/816.png'

import Nft3D4 from '@/static/images/newHome/3d-4.png'

const ChainList = [ Chain1, Chain2, Chain3, Chain4, Chain5, Chain6, Chain7, Chain8, Chain9, Chain10, Chain11, Chain12, Chain13, Chain14, Chain15, Chain16, Chain17, Chain18]
const WalletList = [ Did1, Did2, Did3, Did4, Did5, Did6, Did7, Did8, Did9, Did10, Did11, Did12, Did13, Did14, Did15, Did16]
const SupporterList = [ Supporter1, Supporter2, Supporter3, Supporter4, Supporter5, Supporter6, Supporter7, Supporter8, Supporter9, Supporter10 ]
const PartnerList = [ Partner1, Partner2, Partner3, Partner4, Partner5, Partner6, Partner7, Partner8, Did14 ]
const ProductList = ['Dmail DApp', 'Subscription & Notification', 'Marketing Hub']
const Nft3DList = [
  [Nft3D541, '541'], [Nft3D600, '600'], [Nft3D735, '735'], [Nft3D1927, '1927'],
  [Nft3D425, '425'], [Nft3D2211, '2211'], [Nft3D827, '827'], [Nft3D816, '816'],
]

const Index = ({ store }) => {
  const history = useHistory();
  const { isMobile } = store.common;
  const _SupporterList = isMobile ? [Supporter1, Supporter2, Supporter3, Supporter4, Supporter5, Supporter6] : [...SupporterList]
  const _PartnerList = isMobile ? [[MP9, MP10, MP11, MP12, Partner1, Partner2], [Partner3, Partner4, Partner5, Partner6, Partner7, Partner8]] : [...PartnerList]

  const chainsRef = useRef(null)
  const walletsRef = useRef(null)
  const nft3dsRef = useRef(null)
  useAutoSlide(chainsRef, true)
  useAutoSlide(walletsRef, false)
  useAutoSlide(nft3dsRef, true)

  const dmailAppRef = useRef(null)
  useActionWhenScrollToView(dmailAppRef, () => {
    const dmailDapp = document.querySelector('#__dmailApp')
    dmailDapp && dmailDapp.classList.add('show')
  }, true, () => {
    // const dmailDapp = document.querySelector('#__dmailApp')
    // dmailDapp && dmailDapp.classList.remove('show')
  })

  const supportersRef = useRef(null)
  // useActionWhenScrollToView(supportersRef, (target) => {
  //   const parent = target.parentElement
  //   anime({
  //     targets: parent.querySelectorAll('.supporters li'),
  //     scale: [
  //       {value: 0.5, easing: 'easeOutSine', duration: 300},
  //       {value: 1, easing: 'easeInOutQuad', duration: 800}
  //     ],
  //     delay: anime.stagger(300, {grid: [5, 2], from: 'center'})
  //   });
  //   const partners = target.querySelectorAll('li')
  //   setTimeout(() => {
  //     anime({
  //       targets: partners,
  //       scale: [
  //         {value: 1.8, easing: 'easeOutSine', duration: 300},
  //         {value: 1, easing: 'easeInOutQuad', duration: 800}
  //       ],
  //       delay: anime.stagger(250, {grid: [partners.length, 1], from: 'center'})
  //     });
  //   }, 600);
  // })

  const to3DMarket = () => {
    window.open(NFTsLink)
  }

  const [productTag, setCurrentProduct] = useState(0)
  const [mProductTag, setCurrentMProduct] = useState([true, false, false])
  const _setCurrentMProduct = (index) => () => {
    const _mProductTag = [...mProductTag]
    _mProductTag[index] = !_mProductTag[index]
    setCurrentMProduct(_mProductTag)
  }

  const [datas, setDatas] = useState({
    nfts: [78, 'M'],
    messages: [6874, 'M'],
    transactions: [8632, 'M'],
    users: [283, 'M'],
  })
  // useEffect(() => {
  //   const fn = async (times) => {
  //     if (times > 3) {
  //       return
  //     }
  //     const data = await getHomeData()
  //     if (data) {
  //       setDatas(data)
  //     } else {
  //       await new Promise((resolve) => setTimeout(resolve, 800));
  //       fn(times + 1)
  //     }
  //   }
  //   fn(0)
  // }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Chunk1 className={isMobile ? `sub-mobile` : ''}>
        <Header currentName={''} />
        <div className="center">
          {/* <div className="top-tip">
            <a className="tt" href='https://blog.dmail.ai/dmail-networks-brand-upgrade-and-mainnet-launch/' target='_blank'>
              <SvgsCommons type="notice" width={isMobile ? 14 : 20} />
              <span><span>Mainnet is Live! The $SUBHUB token is coming soon, stay tuned!</span></span>
              &nbsp;🌐<SvgsCommons type="arrow" width={isMobile ? 8 : 13} />
            </a>
          </div> */}
          <div className="slogn">
            <h2>Intelligent and Secure Messaging</h2>
            <h3>Keeping You Informed and Connected.</h3>
            <p>Dmail Network is an AI-powered decentralized messaging infrastructure built to provide encrypted emails, unified notifications, and targeted marketing across multiple chains and dApps for users, developers, marketers and influencers.</p>
          </div>
          <div className="links">
            <a className="filled-red to-dmail" href={EmailLink} target='_blank'>Launch Dmail DApp <SvgsCommons type="arrow" /></a>
            {/* {isMobile ? null : <a className="outlined-red to-sub" href={SubhubHost} target='_blank'>Subscription & Notification</a>} */}
          </div>
          <div className="datas">
            <div className="total">
              <p>
                {Array.isArray(datas.users) ? (
                  <>
                    <NumberAnime num={datas.users[0]} />
                    {datas.users[1]}
                  </>
                ) : '--'}
              </p>
              <span>Total Dmailers</span>
            </div>
            <div className="total">
              <p>
                {Array.isArray(datas.messages) ? (
                  <>
                    <NumberAnime num={datas.messages[0]} />
                    {datas.messages[1]}
                  </>
                ) : '--'}
              </p>
              <span>Messages Interacted</span>
            </div>
            <div className="total">
              <p>
                {Array.isArray(datas.transactions) ? (
                  <>
                    <NumberAnime num={datas.transactions[0]} />
                    {datas.transactions[1]}
                  </>
                ) : '--'}
              </p>              
              <span>On-chain Transactions</span>
            </div>
            <div className="total">
              <p>
                {Array.isArray(datas.nfts) ? (
                  <>
                    <NumberAnime num={datas.nfts[0]} />
                    {datas.nfts[1]}
                  </>
                ) : '--'}
              </p>
              <span>NFT Domains Minted</span>
            </div>
          </div>
        </div>
      </Chunk1>
      <Chunk2 className={isMobile ? `sub-mobile` : ''}>
        <div className="center">
          <h2 style={{ fontSize: isMobile ? '' : '40px' }}>Diversified Products Based on Dmail Messaging Protocol</h2>
          {isMobile ? null : (
            <div className="tab-tags" style={{ width: ProductList.length === 2 ? '465px' : '700px' }}>
              {ProductList.map((name, index) => (
                <strong className={productTag === index ? 'on' : ''} onClick={() => setCurrentProduct(index)} key={index}>{ name }</strong>
              ))}
            </div>
          )}
          <div className={`tab-wrapper tab-length${ProductList.length}`}>
            {isMobile ? null : <div className="blank" ref={dmailAppRef}></div>}
            <div className={`tab-list rotate${productTag}`}>
              {isMobile ? (
                <div className={`tab-tag ${mProductTag[0] ? "on" : ""}`} onClick={_setCurrentMProduct(0)}>
                  <span>{ProductList[0]}</span>
                  <SvgsCommons type="down" width={14} height={7} />
                </div>
              ) : null}
              <div className={`tab-item tab-dmail ${(isMobile ? mProductTag[0] : productTag === 0) ? 'on' : ''}`} id="__dmailApp">
                <div className="thumb"><img src={DmailDapp} width={isMobile ? 271 : 455} /></div>
                <div className="info">
                  <h3>Dmail DApp</h3>
                  <p>Dmail DApp offers a user-self-hosted decentralized mailbox solution, deployed across multiple chains.</p>
                  <div className="actions">
                    <a className="filled-red" onClick={() => history.push(`${newPath}/dapp`)}>Learn more</a>
                    {/* <a className="more" onClick={() => history.push(`${newPath}/dapp`)}>Learn more &gt;&gt;</a> */}
                  </div>
                </div>
              </div>
              {isMobile ? (
                <div className={`tab-tag ${mProductTag[1] ? "on" : ""}`} onClick={_setCurrentMProduct(1)}>
                  <span>{ProductList[1]}</span>
                  <SvgsCommons type="down" width={14} height={7} />
                </div>
              ) : null}
              <div className={`tab-item tab-sub ${(isMobile ? mProductTag[1] : productTag === 1) ? 'on' : ''}`}>
                <div className="thumb"><img src={SubHub} width={isMobile ? 271 : 419} /></div>
                <div className="info">
                  <h3>Subscription & Notification</h3>
                  <p>A powerful messaging and marketing tool for Web3 projects—send personalized, wallet-linked notifications directly to subscribers using DIDs and wallet addresses.</p>
                  <div className="actions">
                    <a className="filled-red" href={SubhubHost} target='_blank'>Learn more</a>
                    {/* <a className="more" href={SubhubHost} target='_blank'>Learn more &gt;&gt;</a> */}
                  </div>
                </div>
              </div>
              {isMobile ? (
                <div className={`tab-tag ${mProductTag[2] ? "on" : ""}`} onClick={_setCurrentMProduct(2)}>
                  <span>{ProductList[2]}</span>
                  <SvgsCommons type="down" width={14} height={7} />
                </div>
              ) : null}
              <div className={`tab-item tab-market ${(isMobile ? mProductTag[2] : productTag === 2) ? 'on' : ''}`}>
                <div className="thumb"><img src={MarketHub} width={isMobile ? 271 : 352} /></div>
                <div className="info">
                  <h3>Marketing Hub</h3>
                  <p>Marketing Hub is a targeted marketing platform where users get paid for viewing ads. Empowers marketers to segment their user profiles and only target messages to wallet addresses that matter.</p>
                  <div className="actions">
                    <a className="filled-red disabled">Coming Soon!</a>
                    <a className="more" href={SubHubLink} target='_blank'>Learn more &gt;&gt;</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="chains">
          <div className="slide" ref={chainsRef}>
            <div className="item" style={{ width: `${ChainList.length * (isMobile ? 120 + 22 : 160 + 30)}px` }}>
              {ChainList.map((value, key) => <img src={value} height={isMobile ? 30 : 40} key={key} />)}
            </div>
          </div>
        </div>
        <div className="wallets">
          <div className="slide" ref={walletsRef}>
            <div className="item" style={{ width: `${WalletList.length * ((isMobile ? 24 : 45) + (isMobile ? 50 : 100))}px` }}>
              {WalletList.map((value, key) => <img src={value} height={isMobile ? 24 : 45} key={key} />)}
            </div>
          </div>
        </div>
      </Chunk2>
      <Chunk3 className={isMobile ? `sub-mobile` : ''}>
        <div className="center">
          <div id="_msgProtocol" style={{ position: 'relative', top: '-80px' }}></div>
          <h2>Dmail Messaging Protocol</h2>
          <div className="desc">
            <p>The Dmail messaging protocol, a proprietary messaging channel crafted by the Dmail team, is grounded in the Web3 identity system. </p>
            <p>With existing integration for 25 different networks including Web2, it allows any application and smart contract to utilize the protocol for secure communication via emails, notifications, and more, thus addressing a crucial communication link in the Web3 infrastructure.</p>
            {/* <p style={{ margin: '20px 0 10px' }}><strong>Dmail Messaging Protocol is now fully open for integration!</strong></p> */}
            {/* <p className="start">
              <span>You can easily integrate it to enable precise email marketing campaigns, event notifications, registration verifications, and more.</span>
              <a className="filled-red" href={EmailLink} target='_blank'>Start for free <SvgsCommons type="arrow" /></a>
            </p> */}
          </div>
          {isMobile ? null : (
            <div className="protocol">
              <ProtocolSvg />
            </div>
          )}
        </div>
        {isMobile ? <img src={Protocol1} width="100%" /> : null}
      </Chunk3>
      <Chunk4 className={isMobile ? `sub-mobile` : ''}>
        <div className="center">
          <h2>Supporters & Partners</h2>
          <ul className="supporters">
            {_SupporterList.map((value, key) => (
              <li key={key}><img src={value} width={216} /></li>
            ))}
          </ul>
          {isMobile ? (
            _PartnerList.map((item, key) => (
              <ul className="partners" key={key} style={{ marginBottom: key !== _PartnerList.length - 1 ? '24px' : '' }}>
                {item.map((value, key) => (
                  <li key={key}><img src={value} width={59} /></li>
                ))}
              </ul>
            ))
          ) : (
            <ul className="partners" ref={supportersRef}>
              {_PartnerList.map((value, key) => (
                <li key={key}><img src={value} width={59} /></li>
              ))}
            </ul>
          )}
        </div>
      </Chunk4>
      <Chunk6 className={isMobile ? `sub-mobile` : ''}>
        <div className="center">
          <div className="title">
            <h2>3D Crystals</h2>
            <a onClick={to3DMarket}>Get Rare Collections &gt;&gt;</a>
          </div>
          <div className="nfts-3d" onClick={to3DMarket}>
            <div className="slide">
              <div ref={nft3dsRef}>
                <ul className="item" style={{ width: `${Nft3DList.length * ((isMobile ? 70 : 86) + (isMobile ? 70 : 170))}px` }}>
                  {Nft3DList.map(([png, id]) => (
                    <li key={id}>
                      <img src={png} alt={`3D Crystals #${id}`} width={isMobile ? 50 : 86} />
                      {/* <strong>3000 Points/month</strong> */}
                      <p>{`3D Crystals #${id}`}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <img src={Nft3D4} width={isMobile ? 100 : 250} alt="" />
          </div>
        </div>
      </Chunk6>
      <Chunk5 className={isMobile ? `sub-mobile` : ''}>
        <div className="center">
          <div className="title">
            <h2>Featured News</h2>
            {/* <a onClick={() => history.push(`${newPath}/news`)}>All news &gt;&gt;</a> */}
            <a href="https://blog.dmail.ai/" target='_blank'>All news &gt;&gt;</a>
          </div>
          <div className="events">
            <News list={HomeNewsList} />
          </div>
        </div>
      </Chunk5>
      <div className="bottom">
        <div className="center">
          <Subscribe />
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))